module.exports = __webpack_public_path__ + "img/solo.2c9c0505.png";